import { render } from "./registration-modals.vue?vue&type=template&id=25bc02a2&scoped=true&ts=true"
import script from "./registration-modals.vue?vue&type=script&lang=ts"
export * from "./registration-modals.vue?vue&type=script&lang=ts"

import "./registration-modals.vue?vue&type=style&index=0&id=25bc02a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bc02a2"]])

export default __exports__